import { Modal as MODAL, Table } from "antd";
import "./style.css";
import { useState } from "react";

type Row = { key: number; number: number; content: string };

type ExamplesModalProps = {
  zmist: any[];
  openModalProp: boolean;
  onClose?: () => void;
  onPick?: (row: Row) => void;
};


const columns = [
  {
    title: '№',
    dataIndex: 'key',
    key: 'key',
    width: 50,
    // fixed: 'left'
  },
  {
    title: 'Content',
    dataIndex: 'text_rezoluzia',
    key: 'id',
    width: 500,
    ellipsis: true,
  }
];

export default function ExamplesModal({zmist, openModalProp, onClose, onPick }: ExamplesModalProps ) {
    const [selectedRow, setSelectedRow] = useState<number>();

    const handleRowClick = (record: Row) => {
        if(record) setSelectedRow(record.key);

        console.log("ROW EXAMPLES ", record);
        onPick?.(record);   // передати далі
        // за потреби: onClose?.(); // закрити модалку після вибору
    };
    
    return (
        <>
            <MODAL open={openModalProp} 
                    onCancel={onClose} 
                    closable={false} 
                    width={700} 
                        styles={{ content: { height: 600 },
                        body: { height: '500px', padding: 0 }, 
                        footer: {marginTop: 20} }}
                    okButtonProps={{ style: { display: 'none' } }}
                    okText="Зберегти"
                    cancelText="Закрити"
                >
            <div className="fullTable">
                <Table
                    dataSource={zmist}
                    columns={columns} 
                    bordered 
                    rowKey={(r) => r.id}
                    // pagination={{pageSize: 10, position: ['bottomCenter'] }} 
                    pagination={false} 
                    size="small" 
                    scroll={{ y: 500, x: 'max-content' }}
                    tableLayout="fixed"
                    onRow={(record) => ({
                        onClick: () => handleRowClick(record),   // ← ключ
                    })}
                    rowClassName={(record) => record.key === selectedRow ? "clickable-row" : 'style-row'}
                />
            </div>
            </MODAL>
        </>
    )
}

